import { useQuery } from '@apollo/client';
import { Button, Divider, Transfer, Typography } from 'antd'
import React, { useState } from 'react'
import { useEffect } from 'react';
import { useRef } from 'react';
import { GET_LEAD } from '../../Graphql/queries/getQueries';
import CustomModal from '../CustomModal/CustomModal';
import Spiner from '../Spiner/Spiner';

const LeadAssignee = ({ leadId }) => {
    const { error, loading, data } = useQuery(GET_LEAD, {
        variables: {
            value: leadId
        },
    })

    const { user: users } = !loading && data?.Leads?.nodes[0]
    const leadUsers = users?.map((user, i) => {
        return {
            key: i,
            assigned: true,
            name: user.name,
        }
    })

    const [assigneeData, setAssigneeData] = useState(leadUsers)


    const assignedUsers = leadUsers?.filter((item) => item.assigned === true).map((user, i) => {
        return <Typography.Text key={i}>{user.name} </Typography.Text>
    })

    const [open, setOpen] = useState(false);

    const showModal = () => {
        setOpen(true);
    };
    const handleOk = () => {

        setOpen(false);
    };
    const handleCancel = () => {
        console.log('Clicked cancel button');
        setOpen(false);
    };
    if (loading) return <Spiner />
    return (
        <div className='lead_comp_container '>
            <div className='flex_ver_space_between' style={{ height: 200 }} >
                <div className='flex_ver_space_between' style={{ height: 56, }} >
                    <Typography.Title level={5}>Assigned to</Typography.Title>
                    {assignedUsers}
                </div>
                <Divider style={{ width: '100%', margin: 0 }} />
                <CustomModal title='Share/Add assignee' open={open} handleOk={handleOk} handleCancel={handleCancel} >
                    <AssigneeModalContent assigneeData={assigneeData} setAssigneeData={setAssigneeData} />
                </CustomModal>
                <Button type="primary"
                    style={{ background: '#1A99CA', borderRadius: 8, height: 40 }}
                    onClick={showModal}
                >Share/Add assignee</Button>
            </div>
        </div>
    )
}

export default LeadAssignee

export function AssigneeModalContent({ assigneeData, setAssigneeData }) {


    const initialTargetKeys = assigneeData?.filter((item) => item.assigned === true).map((item) => item.key);
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [targetKeys, setTargetKeys] = useState(initialTargetKeys);


    const onChange = (nextTargetKeys, direction, moveKeys) => {
        setTargetKeys(nextTargetKeys);
        setAssigneeData((prev) => prev.map(d => nextTargetKeys.includes(d.key) ? { ...d, assigned: false } : { ...d, assigned: true }))
    };


    const onSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
        setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
    };

    const onScroll = (direction, e) => {
        console.log('direction:', direction);
        console.log('target:', e.target);
    };

    return (
        <>
            <Transfer
                className='leed_assignee'
                dataSource={assigneeData}
                titles={['Unassigned', 'Assigned']}
                targetKeys={targetKeys}
                selectedKeys={selectedKeys}
                onChange={onChange}
                onSelectChange={onSelectChange}
                // onScroll={onScroll}
                render={(item) => item.name}
            />
        </>
    )
}